jQuery(function ($) {
	function scrollChk() {
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();

		// 視界に入ったらファイドイン
		jQuery('.js-in').not('.is-active').each(function () {
			var pos = $(this).offset().top;

			if (scroll > pos - windowHeight) {
				$(this).addClass("is-active");
			}
		});

		// 順番フェイドイン
		if (window.matchMedia("(min-width: 767px)").matches) {
			var setHeight = 200;
		} else {
			var setHeight = 100;
		}

		$('.fadeIn_list').each(function () {
			var targetPosition = $(this).offset().top;
			if (scroll > targetPosition - windowHeight + setHeight) {
				$(this).addClass('show');
			}
		})
	}
	$(window).scroll(function () {
		scrollChk();
	});
	$('body').on('touchmove', function () {
		scrollChk();
	});
});

// 背景動画（.js-bg-video）：動きを減らす設定の環境では再生しない
(function () {
	if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
	function stopBgVideos() {
		document.querySelectorAll('.js-bg-video').forEach(function (v) {
			v.removeAttribute('autoplay');
			v.pause();
		});
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', stopBgVideos);
	} else {
		stopBgVideos();
	}
})();

// スクロール出現（.js-scrollin → .is-show）IntersectionObserver版
// jQueryスクロールハンドラより軽く、初期表示内の要素も確実に発火する
(function () {
	function initScrollin() {
	var targets = document.querySelectorAll('.js-scrollin');
	if (!targets.length) return;
	if (!('IntersectionObserver' in window)) {
		targets.forEach ? targets.forEach(function (el) { el.classList.add('is-show'); }) : null;
		return;
	}
	var io = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-show');
				io.unobserve(entry.target);
			}
		});
	}, { rootMargin: '0px 0px -10% 0px' });

	// 最初の画面に入っているもの（と、すぐ下にあるもの）は、スクロールを待たずに出す。
	// 監視の判定は「画面の下から10%内側に入ったら」なので、開いた直後はどれも
	// その範囲に届かず、ヒーローの下が真っ白なまま残ってしまうため。
	targets.forEach(function (el) {
		if (el.getBoundingClientRect().top < window.innerHeight * 1.1) {
			el.classList.add('is-show');
			return;
		}
		io.observe(el);
	});
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initScrollin);
	} else {
		initScrollin();
	}
})();

$(window).on("load", function () {
	//ロードしてからスライド
	$('.js-load').delay(1000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});

	$('.js-load-more').delay(2000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});
});
